import { SplitFiestaLoading } from './SplitFiestaLoading';

interface TabContentLoaderProps {
  className?: string;
  height?: string;
}

/**
 * Reusable loader component for tab content
 * Shows a centered spinner while tab content is loading
 */
export function TabContentLoader({
  className = '',
  height = 'h-64',
}: TabContentLoaderProps) {
  return (
    <div
      className={`flex justify-center items-center ${height} ${className}`}
      data-testid="tab-content-loader"
    >
      <SplitFiestaLoading className="bg-transparent" />
    </div>
  );
}
